export const OVERLAY_QR = {
  errorCorrectionLevel: "L" as const,
  margin: 2,
  colorDark: "#000000",
  colorLight: "#00000000",
};

export const SHARE_QR = {
  errorCorrectionLevel: "M" as const,
  margin: 2,
  colorDark: "#000000",
  colorLight: "#00000000",
};

export const SHARE_QR_PREVIEW_PX = 160;
export const SHARE_QR_SVG_PX = 512;
export const SHARE_QR_PNG_PX = 2000;

export const BACKGROUND_PREVIEW_QR_PX = 134;
